import React from 'react';

import '../css/Feedback.css';
import firebase from 'firebase';

class Feedback extends React.Component {
  state = {
    rating: null,
    suggestion: null,
    email: null,
    fb: null,
  }
  componentDidMount() {
    firebase.firestore().collection('feedback').onSnapshot((result) => {
      let docs = result.docs;
      let feedback = docs.map((doc, pos) => {
        let data = doc.data();
        data.id = doc.id;
        return data;
      });
      this.setState({fb: feedback});
      console.log(this.state.fb);
    });
  }
  render() {
    return(
      <div className="fb-main">
        <div class="logo_name">
          <div className="logo-img">
            <img src="logo.png" />
          </div>
          <div className="logo_text">
            <h1 className="name">सारथी</h1>
            <h3 class="slogan">Your Travel Partner!</h3>
          </div>
        </div>
        <div class="feedback-form">
          <h2>Please do fill the feedback form and let us know about any queries</h2>
          <label>How would you rate the service of <strong>Sarathi</strong>?</label>
          <select className="option-select" name="rating" onChange={(e)=>{this.setState({rating: e.target.value})}} required>
            <option value="none">Select</option>
            <option value="5">Very Good</option>
            <option value="4">Excellent</option>
            <option value="3">Good</option>
            <option value="2">Average</option>
            <option value="1">Poor</option>
          </select>
          <br />
          <br />
          <label>What would you suggest Sarathi to include in the future updates?</label>
          <br />
          <div className="textArea">
            <textarea name="suggestion" value={this.state.suggestion} onChange={(e)=>{this.setState({suggestion: e.target.value})}} required></textarea>
          </div>
          <br />
          <br />
          <input type="email" name="email" value={this.state.email} onChange={(e)=>{this.setState({email: e.target.value})}} placeholder="Enter your email (optional)" />
          <br />
          <br />
          <input type="submit" name="submit" value="Submit" onClick={this.updateFb}/>
        </div>
      </div>
    );
  }

  updateFb = () => {
    if(this.state.suggestion && this.state.rating) {
      let updatedFb = {
        email: this.state.email,
        rating: this.state.rating,
        suggestion: this.state.suggestion,
      }
      firebase.firestore().collection('feedback').add(updatedFb);
      alert("We received your feedback!\nThanks for your valuable time!");
      setTimeout(function(){ window.location.reload(); }, 500);
    } else {
      alert("Please enter the mentioned credentials (email-id is optional).")
    }
  }
}

export default Feedback;
